import React from 'react';
import { Link as RouterLink } from 'react-router';
import { useForm, Controller } from 'react-hook-form';
import { Alert, Box, Link, Paper, Stack, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { useRouter } from '@cvt/routing';
import { LocalizationContext } from '@cvt/contexts';
import { emailRegex } from '@cvt/helpers/validation';

import { AuthContext } from '../contexts/AuthContext';
import { LoggedOutActionsLayout } from '../components/LoggedOutActionsLayout';


export const ResetPassword = () => {

  const router = useRouter();
  const [success, setSuccess] = React.useState(false);
  const { dictionary } = React.useContext(LocalizationContext);
  const { resetPassword } = React.useContext(AuthContext);
  const { control, setError, handleSubmit, formState: { isSubmitting, errors } } = useForm({
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = React.useCallback(async (data: Auth.ResetPassword) => {
    try {
      resetPassword(data.email);
      setSuccess(true);
    } catch(e: any) {
      // @ts-ignore
      setError('email', { type: 'error', message: dictionary.auth.firebase.errors[e.error] || e.message });
      setSuccess(false);
    }
  }, [setError, dictionary, resetPassword]);

  return (
    <LoggedOutActionsLayout>
      <Stack direction="row" alignItems="center" justifyContent="center" mb={3} position="relative">
        <Typography variant="h1" align="center">
          {dictionary.auth.resetPassword.title}
        </Typography>
      </Stack>
      <Paper component={Box} elevation={1} p={3}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="email"
            control={control}
            rules={{
              required: dictionary.forms.validations.required,
              pattern: {
                value: emailRegex,
                message: dictionary.forms.validations.invalidEmail,
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                variant="outlined"
                label={dictionary.forms.fieldEmail}
                name="email"
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            )}
          />
          <Box mt={3}>
            <LoadingButton fullWidth loading={isSubmitting} size="large" type="submit" variant="contained" color="primary">
              {dictionary.auth.resetPassword.buttonReset}
            </LoadingButton>
          </Box>
          {success && (
            <Box mt={3}>
              <Alert severity="success">{dictionary.auth.resetPassword.passwordResetEmailSent}</Alert>
            </Box>
          )}
        </form>
      </Paper>
      <Box mt={3} textAlign="center">
        <Stack direction="row" justifyContent="center" alignItems="center" mt={1}>
          <Typography variant="body2" color="secondary.dark">
            <Link
              component={RouterLink}
              to={router.auth.login.path}
              underline="hover"
              color="inherit"
            >
              {dictionary.auth.resetPassword.buttonLogin}
            </Link>
          </Typography>
        </Stack>
      </Box>
    </LoggedOutActionsLayout>
  );
};
